<div class="container" [ngClass]="status">
  <div class="content">
    <mat-icon *ngIf="status === 'success'" class="success" aria-hidden="true" data-testid="notification-icon">check_circle</mat-icon>
    <mat-icon *ngIf="status === 'error'" class="error" aria-hidden="true" data-testid="notification-icon">error</mat-icon>
    <mat-icon *ngIf="status === 'warning'" class="warning" aria-hidden="true" data-testid="notification-icon">warning</mat-icon>
    <mat-icon *ngIf="status === 'info'" class="info" aria-hidden="true" data-testid="notification-icon">info</mat-icon>

    <span>{{ message }}</span>
  </div>

  <mat-icon class="close" tabindex="0" role="button" aria-label="Dismiss" data-testid="notification-close" (click)="close()">close</mat-icon>
</div>
